<template>
	<div class="ThumbnailsSlider">
		<div class="ThumbnailsSlider-prev"
			 :class="getPrevBtbClass()"
			 @click="handlePrevBtnClick">
			<i class="fa fa-angle-left"></i>
		</div>
		<div class="ThumbnailsSlider-list">
			<div class="ThumbnailItem"
				 :class="getThumbnailClass(thumbnail)"
				 v-for="thumbnail in thumbsRange"
				 :key="thumbnail"
				 @click="changePage(thumbnail)">
				<div class="ThumbnailItem-img">
					<div class="ThumbnailItem-img-background" :style="getThumbnailStyle(thumbnail)"></div>
					<!--<img :src="thumbnailUrls[thumbnail]">-->
					<!--<div class="ThumbnailItem-img-loader">
						<i class="fa fa-spinner fa-pulse fa-2x fa-fw"></i>
					</div>-->
				</div>
				<div class="ThumbnailItem-text">
					{{thumbnail}}
				</div>
			</div>
		</div>
		<div class="ThumbnailsSlider-next"
			 :class="getNextBtnClass()"
			 @click="handleNextBtnClick">
			<i class="fa fa-angle-right"></i>
		</div>
	</div>
</template>
<script type="text/javascript">
	import range from 'lodash/range';
	import debounce from 'lodash/debounce';

	export default {
		components: {},
		props: [
			'url',
			'pageCount',
			'generateUrl',
			'currentPage',
			'changePage',
		],
		watch: {
			url(){
				this.createThumbs();
			},
			pageCount(){
				this.createThumbs();
			},
			currentPage: {
				immediate: true,
				handler() {
					if (this.currentPage) {
						this.currentThumbsPage = Math.floor(this.currentPage / this.visibleThumbsNumber) + 1;
					}
				}
			}
		},
		created(){
			this.$window = $(window);
			this.$window.on('resize', this.handleWindowResize);
			this.calcVisibleThumbsNumber();
			this.createThumbs();
		},
		destroyed(){
			this.$window.off('resize', this.handleWindowResize)
		},
		data() {
			return {
				thumbnails: [],
				visibleThumbsNumber: 10,
				currentThumbsPage: 1,
				thumbnailUrls: [],
				$window: null
			};
		},
		computed: {
			thumbsRange() {
				const start = ((this.currentThumbsPage - 1) * this.visibleThumbsNumber) + 1;
				const max = Math.abs(this.pageCount - (this.currentThumbsPage - 1) * this.visibleThumbsNumber);
				const end = start + Math.min(this.visibleThumbsNumber, max);

				return range(start, end);
			},
		},
		methods: {
			createThumbs() {
				this.thumbnailUrls = new Array(this.pageCount).fill(null)
					.reduce((accumulator, unused, index) => {
						const page = index + 1;
						accumulator[page] = this.generateUrl(page);
						return accumulator;
					}, []);
			},
			handleThumbnailClick(page) {
				this.changePage(page);
			},
			getThumbnailClass(thumbnail) {
				return this.currentPage === thumbnail ? 'is-current' : '';
			},
			handlePrevBtnClick() {
				this.currentThumbsPage = Math.max(1, this.currentThumbsPage - 1);
			},
			handleNextBtnClick() {
				if (!this.canGoToPage()) return false;
				this.currentThumbsPage = Math.min(this.currentThumbsPage + 1, this.pageCount);
			},
			getPrevBtbClass() {
				return this.currentThumbsPage === 1 ? 'is-disabled' : null;
			},
			getNextBtnClass() {
				return this.canGoToPage(this.currentThumbsPage + 1) ? null : 'is-disabled';
			},
			getThumbnailStyle(thumbnail) {
				return `background-image: url(${this.thumbnailUrls[thumbnail]})`;
			},
			canGoToPage(pageNum = this.currentThumbsPage){
				return (pageNum * this.visibleThumbsNumber) < this.pageCount;
			},
			calcVisibleThumbsNumber(){
				const width = this.$window.width();
				if (width >= 1280) {
					this.visibleThumbsNumber = 10;
				} else if (width >= 992) {
					this.visibleThumbsNumber = 5;
				} else {
					this.visibleThumbsNumber = 3;
				}
			},
			handleWindowResize: debounce(function () {
				this.calcVisibleThumbsNumber();
			}, 500)
		},
	};

</script>
<style lang="css">
	.ThumbnailsSlider {
		background: whitesmoke;
		z-index: 1000;
		padding: 5px 0;
		display: flex;
	}

	.ThumbnailsSlider-prev,
	.ThumbnailsSlider-next {
		background: none !important;
		padding: 0 10px;
		width: auto;
		height: auto;
		margin-top: 0;
		font-size: 30px;
		display: flex;
		align-content: center;
		align-items: center;
		cursor: pointer;
	}

	.ThumbnailsSlider-prev.is-disabled,
	.ThumbnailsSlider-next.is-disabled {
		cursor: default;
		opacity: 0.2;
	}

	.ThumbnailsSlider-list {
		display: flex;
		flex-grow: 1;
	}

	.ThumbnailItem {
		padding: 0 5px;
		text-align: center;
		display: flex;
		flex-direction: column;
		min-height: 75px;
		cursor: pointer;
		flex-grow: 1;
		flex-basis: 0;
		max-width: 10%;
	}

	.ThumbnailItem.is-current .ThumbnailItem-text {
		font-weight: bold;
		color: #337ab7;
	}

	.ThumbnailItem .ThumbnailItem-img {
		flex-grow: 1;
		position: relative;
		transition: all 0.2s;
		margin-bottom: 3px;
	}

	.ThumbnailItem:hover .ThumbnailItem-img {
		transform: scale(1.1);
	}

	.ThumbnailItem .ThumbnailItem-img img {
		width: 100%;
		max-width: 100px;
		max-height: 50px;
		margin: 0 auto;
		display: block;
		z-index: 20;
		position: relative;
	}

	.ThumbnailItem .ThumbnailItem-img .ThumbnailItem-img-background {
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		z-index: 10;
		background-size: contain;
		background-repeat: no-repeat;
		background-position: 50% 50%;

	}

	.ThumbnailItem .ThumbnailItem-img .ThumbnailItem-img-loader {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%, -50%);
		z-index: 5;
	}

	.ThumbnailItem .ThumbnailItem-text {
		font-size: 10px;
		flex-shrink: 1;
	}
</style>



// WEBPACK FOOTER //
// ThumbnailsSlider.vue?18b148e7